import { Box } from '@mui/material'
import { useMemo } from 'react'
import { InventoryParametersTableProps } from './Tables.types'
// Toolbar and modal imports removed - functionality moved to BaseTable
import { format } from 'date-fns'
// DropZone now integrated into BaseTable toolbar
import { BaseTable } from 'Features/Table/BaseTable.view'
import { ExtendedGridColDef } from 'Features/Table/BulkUpdateModal'

const numericalFields = [
  'replenishmentMinimumOrderQuantity',
  'replenishmentMinimumOrderIncrement',
  'volumePercentageExcess',
  'volumePercentageShort',
  'salesRatePeriod',
]
const stringFields: string[] = []
export const InventoryParameterTable = ({
  data,
  isLoading,
  updateTableData,
  updateParametersData,
  isUploading,
}: InventoryParametersTableProps) => {
  // Modal state and handlers removed - bulk update now handled by BaseTable toolbar

  const columns: ExtendedGridColDef[] = useMemo(
    () => [
      {
        headerName: 'Base source site code',
        field: 'baseSourceSiteCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Site code',
        field: 'siteCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'SKU code',
        field: 'skuCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Source site code',
        field: 'sourceSiteCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Supply type code',
        field: 'supplyTypeCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Deployment lead time',
        field: 'deploymentLeadTime',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'Safety stock days',
        field: 'safetyStockDays',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'Min safety stock',
        field: 'MinSafetyStock',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'Max safety stock',
        field: 'MaxSafetyStock',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'Business driven stock policy',
        field: 'businessDrivenStockPolicy',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Replenishment minimum order quantity',
        field: 'replenishmentMinimumOrderQuantity',
        flex: 1,
        type: 'number',
        editable: true,
      },
      {
        headerName: 'Replenishment minimum order increment',
        field: 'replenishmentMinimumOrderIncrement',
        flex: 1,
        type: 'number',
        editable: true,
      },
      {
        headerName: 'Volume percentage excess',
        field: 'volumePercentageExcess',
        flex: 1,
        type: 'number',
        editable: true,
      },
      {
        headerName: 'Volume percentage short',
        field: 'volumePercentageShort',
        flex: 1,
        type: 'number',
        editable: true,
      },
      {
        headerName: 'Sales rate period',
        field: 'salesRatePeriod',
        flex: 1,
        type: 'number',
        editable: true,
      },
      {
        headerName: 'Valid from date',
        field: 'validFromDate',
        flex: 1,
        type: 'string',
        valueFormatter: (params) => {
          if (!params) return ''
          return format(new Date(params), 'yyyy-MM-dd')
        },
      },
      {
        headerName: 'Valid to date',
        field: 'validToDate',
        flex: 1,
        type: 'string',
        valueFormatter: (params) => {
          if (!params) return ''
          return format(new Date(params), 'yyyy-MM-dd')
        },
      },
    ],
    [data]
  )

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
      }}
    >
      {/* Modal removed - bulk update now handled by BaseTable toolbar */}
      <BaseTable
        data={data ?? []}
        columns={columns}
        isLoading={isLoading}
        updateTableData={updateTableData}
        uploadData={updateParametersData} // Pass upload function to BaseTable
        isUploading={isUploading}
        isSaving={false}
        checkBoxSelection={true}
        showTableToolBar={true}
        pinnedColumns={['baseSourceSiteCode', 'siteCode', 'skuCode']}
        downloadFileName="InventoryParameters"
      />
    </Box>
  )
}
